<template>
  <div class="table-wrapper">
    <table :class="['table', `table--${size}`]">
      <thead>
        <tr>
          <th v-for="label in headerLabels" :key="`table-head-${label}`">
            {{ label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in data"
          :key="`table-row-${tableKeyName}-${index}`"
        >
          <td
            v-for="cellKey in Object.keys(row)"
            :key="`table-cell-${tableKeyName}-${index}-${cellKey}`"
          >
            {{ row[cellKey] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Table",
  props: {
    data: {
      type: Array,
      default: null
    },
    labels: {
      type: Array,
      default: null
    },
    size: {
      type: String,
      default: ""
    }
  },
  computed: {
    tableKeyName() {
      return this.data[0] ? Object.keys(this.data[0])[0] : "";
    },
    headerLabels() {
      if (this.labels) {
        return this.labels;
      }
      return this.data[0] ? Object.keys(this.data[0]) : [];
    }
  }
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: rem(10) 0 rem(10) rem(30);
  text-align: left;
  border-bottom: 1px solid $--color-border-primary;
  &:last-child {
    padding-right: rem(30);
  }
}

thead {
  th {
    max-width: 210px;
    font-weight: bold;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    border-bottom: 1px solid $--color-border-primary;
    color: $--color-primary;
  }
}

tbody {
  td {
    border-bottom: 1px solid $--color-border-primary;
  }
}

.table--sm {
  td {
    font-size: rem(14);
  }
}
</style>
